module.exports = __webpack_public_path__ + "static/media/preview_payments.01418040.PNG";